import React from 'react';
import { useTheme } from '../theme/ThemeContext';
import { useSelector } from 'react-redux';
import { selectUser } from '../redux/features/platformSlice';
import { UserIcon, HashIcon, GlobeIcon, BriefcaseIcon } from '../helpers/Icons';

const Profile = () => {
  const theme = useTheme();
  const user = useSelector(selectUser);
  const account = useSelector(s => s.platform.account);

  const Card = ({ title, value, icon: Icon }) => (
    <div style={{ background: theme.card2, padding: 20, borderRadius: 12, border: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', gap: 15 }}>
      <div style={{ width: 40, height: 40, borderRadius: 10, background: `${theme.primary}15`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon s={20} c={theme.primary} />
      </div>
      <div>
        <div style={{ fontSize: 11, color: theme.textM, marginBottom: 2 }}>{title}</div>
        <div style={{ fontSize: 14, fontWeight: 700, color: theme.text }}>{value}</div>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 24, maxWidth: 800, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 32 }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: `linear-gradient(135deg, ${theme.primary}, #6366f1)`, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: `0 10px 30px ${theme.primary}44` }}>
          <UserIcon s={40} c="#fff" />
        </div>
        <div>
          <h2 style={{ fontSize: 24, fontWeight: 800, color: theme.text, margin: 0 }}>{user?.name || 'Demo User'}</h2>
          <div style={{ fontSize: 13, color: theme.textM }}>{user?.email || 'demo@example.com'}</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 16 }}>
        <Card title="Account ID" value={account?.login || 'N/A'} icon={HashIcon || UserIcon} />
        <Card title="Server" value={account?.server || 'Demo'} icon={GlobeIcon} />
        <Card title="Account Group" value={user?.group_id?.group_name || 'Standard'} icon={BriefcaseIcon} />
        <Card title="Currency" value={account?.currency || 'USD'} icon={GlobeIcon} />
      </div>

      <div style={{ marginTop: 32, padding: 20, background: `${theme.primary}08`, borderRadius: 12, border: `1px dashed ${theme.primary}33` }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: theme.primary, marginBottom: 8 }}>Verification Status</div>
        <div style={{ fontSize: 12, color: theme.textS, lineHeight: 1.5 }}>
          Your account is currently in **Demo Mode**. To trade with real funds, please complete the verification process in the client portal.
        </div>
      </div>
    </div>
  );
};

export default Profile;
